import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.paceestate.com';

const marketingService = {
  // Email Campaigns
  getCampaigns: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await axios.get(`${API_URL}/api/marketing/campaigns?${params}`);
    return response.data;
  },

  getCampaign: async (id) => {
    const response = await axios.get(`${API_URL}/api/marketing/campaigns/${id}`);
    return response.data;
  },

  createCampaign: async (data) => {
    const response = await axios.post(`${API_URL}/api/marketing/campaigns`, data);
    return response.data;
  },

  updateCampaign: async (id, data) => {
    const response = await axios.put(`${API_URL}/api/marketing/campaigns/${id}`, data);
    return response.data;
  },

  deleteCampaign: async (id) => {
    const response = await axios.delete(`${API_URL}/api/marketing/campaigns/${id}`);
    return response.data;
  },

  sendCampaign: async (id) => {
    const response = await axios.post(`${API_URL}/api/marketing/campaigns/${id}/send`);
    return response.data;
  },

  scheduleCampaign: async (id, scheduledAt) => {
    const response = await axios.post(`${API_URL}/api/marketing/campaigns/${id}/schedule`, {
      scheduled_at: scheduledAt
    });
    return response.data;
  },

  getCampaignAnalytics: async (id) => {
    const response = await axios.get(`${API_URL}/api/marketing/campaigns/${id}/analytics`);
    return response.data;
  },

  // Email Templates
  getTemplates: async () => {
    const response = await axios.get(`${API_URL}/api/marketing/templates`);
    return response.data;
  },

  getTemplate: async (id) => {
    const response = await axios.get(`${API_URL}/api/marketing/templates/${id}`);
    return response.data;
  },

  // Social Media
  getSocialPosts: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await axios.get(`${API_URL}/api/marketing/social?${params}`);
    return response.data;
  },

  getSocialPost: async (id) => {
    const response = await axios.get(`${API_URL}/api/marketing/social/${id}`);
    return response.data;
  },

  createSocialPost: async (data) => {
    const response = await axios.post(`${API_URL}/api/marketing/social`, data);
    return response.data;
  },

  updateSocialPost: async (id, data) => {
    const response = await axios.put(`${API_URL}/api/marketing/social/${id}`, data);
    return response.data;
  },

  deleteSocialPost: async (id) => {
    const response = await axios.delete(`${API_URL}/api/marketing/social/${id}`);
    return response.data;
  },

  scheduleSocialPost: async (id, scheduledAt) => {
    const response = await axios.post(`${API_URL}/api/marketing/social/${id}/schedule`, {
      scheduled_at: scheduledAt
    });
    return response.data;
  },

  // Promotions
  getPromotions: async (activeOnly = false) => {
    const params = activeOnly ? '?active_only=true' : '';
    const response = await axios.get(`${API_URL}/api/marketing/promotions${params}`);
    return response.data;
  },

  getPromotion: async (id) => {
    const response = await axios.get(`${API_URL}/api/marketing/promotions/${id}`);
    return response.data;
  },

  createPromotion: async (data) => {
    const response = await axios.post(`${API_URL}/api/marketing/promotions`, data);
    return response.data;
  },

  updatePromotion: async (id, data) => {
    const response = await axios.put(`${API_URL}/api/marketing/promotions/${id}`, data);
    return response.data;
  },

  deletePromotion: async (id) => {
    const response = await axios.delete(`${API_URL}/api/marketing/promotions/${id}`);
    return response.data;
  },

  validatePromotion: async (code, purchaseAmount) => {
    const response = await axios.post(`${API_URL}/api/marketing/promotions/validate`, {
      code,
      purchase_amount: purchaseAmount
    });
    return response.data;
  },

  generatePromoCode: async (id) => {
    const response = await axios.post(`${API_URL}/api/marketing/promotions/${id}/generate-code`);
    return response.data;
  }
};

export default marketingService;
